import './spin.css';
import { SpinProps } from './spin.props';

const Spin = ({ spin = true, size = 12, className = '' }: SpinProps) => {
  return (
    <div
      className={`isg-spin ${spin ? 'visible' : ''} ${className}`}
      style={{ width: size, height: size }}
    />
  );
};

export default Spin;
